import { jsx as e, jsxs as s } from "react/jsx-runtime";

import { useCallback as t } from "react";

import o from "@ui-components-3/icons/lib/solid/ArrowLeft";

import i from "@ui-components-3/icons/lib/solid/ArrowRight";

import { addWeeks as a, addMonths as r, format as n } from "date-fns";

import l from "@ui-components-3/ui/lib/utils/classNames";

import { useProviderSchedule as m } from "../../hooks/useProviderSchedule.js";

const u = () => {
    const {date: u, onChangeDate: c, mode: d, variantClassNames: p} = m(), f = "week" === d, h = t((e => () => {
        c((f ? a : r)(u, e));
    }), [ u, f, c ]);
    return e("div", {
        className: "gap-s flex w-full flex-wrap items-center justify-between",
        children: s("div", {
            className: "gap-m flex w-full justify-between sm:w-auto sm:justify-start",
            children: [ e("h2", {
                className: l("typography-body-xxl font-semibold", p.textMain),
                children: n(u, "MMMM y")
            }), s("div", {
                className: "gap-xs flex",
                children: [ e("button", {
                    type: "button",
                    className: l("btn-unsized p-xs", p.buttonBorderless),
                    "aria-label": `Previous ${d}`,
                    onClick: h(-1),
                    children: e(o, {
                        "aria-hidden": "true",
                        className: "w-s h-auto shrink-0"
                    })
                }), e("button", {
                    type: "button",
                    className: l("btn-unsized p-xs", p.buttonBorderless),
                    "aria-label": `Next ${d}`,
                    onClick: h(1),
                    children: e(i, {
                        "aria-hidden": "true",
                        className: "w-s h-auto shrink-0"
                    })
                }) ]
            }) ]
        })
    });
};

export { u as default };
//# sourceMappingURL=NavControls.js.map
